var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{staticClass:"btn-custom-danger",on:{"click":function($event){$event.preventDefault();return _vm.confirmDelete.apply(null, arguments)}}},[_c('Icon',{attrs:{"icon":"trash","size":20,"fill":"#85a1b4"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }